import React from 'react';

export default function Footer() {
  return (
    <footer style={{ backgroundColor: '#0a1c3a', color: '#e2e8f0', fontFamily: "'Montserrat', sans-serif" }} className="pt-5 pb-3 mt-5">
      <div className="container pt-4">
        <div className="row g-4 mb-5">
          
          {/* Column 1: Brand & About */}
          <div className="col-lg-5 col-md-6 pe-lg-5">
            <div className="d-flex align-items-center gap-2 mb-4">
              {/* Sun SVG Icon */}
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#ffc107" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="5"></circle>
                <line x1="12" y1="1" x2="12" y2="3"></line>
                <line x1="12" y1="21" x2="12" y2="23"></line>
                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
                <line x1="1" y1="12" x2="3" y2="12"></line>
                <line x1="21" y1="12" x2="23" y2="12"></line>
                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
              </svg>
              <h4 className="fw-bolder mb-0 text-white" style={{ letterSpacing: '1px' }}>DIVINE SOLAR ENERGY</h4>
            </div>
            <p className="text-white-50 mb-4" style={{ lineHeight: '1.8', fontSize: '0.95rem' }}>
              Leading providers of premium solar solutions including Rooftop Systems, Inverters, Water Heaters, and Pumps. We are dedicated to providing robust, eco-friendly, and cost-effective power solutions to empower a greener tomorrow.
            </p>
            {/* Social Media Placeholder Icons */}
            <div className="d-flex gap-3">
              <a href="#home" className="text-white-50 hover-shadow transition" style={{ textDecoration: 'none' }}>
                <div className="bg-white bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/></svg>
                </div>
              </a>
              <a href="#home" className="text-white-50 hover-shadow transition" style={{ textDecoration: 'none' }}>
                <div className="bg-white bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>
                </div>
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="col-lg-3 col-md-6 px-lg-4">
            <h5 className="fw-bold text-white mb-4">Quick Links</h5>
            <ul className="list-unstyled d-flex flex-column gap-3">
              <li><a href="#home" className="text-white-50 text-decoration-none footer-link">Home</a></li>
              <li><a href="#about" className="text-white-50 text-decoration-none footer-link">About Us</a></li>
              <li><a href="#services" className="text-white-50 text-decoration-none footer-link">Our Services</a></li>
              <li><a href="#contact" className="text-white-50 text-decoration-none footer-link">Contact Us</a></li>
            </ul>
          </div>

          {/* Column 3: Contact Info */}
          <div className="col-lg-4 col-md-12">
            <h5 className="fw-bold text-white mb-4">Contact Info</h5>
            <ul className="list-unstyled d-flex flex-column gap-3 text-white-50">
              <li className="d-flex align-items-start gap-3">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ffc107" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mt-1 flex-shrink-0"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                <span>Sector-11, Indira Nagar, Lucknow - 226016, UP</span>
              </li>
              <li className="d-flex align-items-center gap-3">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ffc107" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="flex-shrink-0"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                <span>+91 9906044032 / 9260917766</span>
              </li>
              <li className="d-flex align-items-center gap-3">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ffc107" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="flex-shrink-0"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                <span style={{ wordBreak: 'break-all' }}>dsesps234@gmail.com</span>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom Footer (Copyright & Certifications) */}
        <div className="border-top pt-4 mt-4 d-flex flex-column flex-md-row justify-content-between align-items-center" style={{ borderColor: 'rgba(255,255,255,0.1) !important' }}>
          <p className="mb-3 mb-md-0 text-white-50 small">
            &copy; {new Date().getFullYear()} <span className="text-white fw-semibold">Divine Solar Energy</span>. All Rights Reserved.
          </p>
          <div className="text-white-50 small text-center text-md-end">
            <span className="fw-bolder text-warning">GSTIN:</span> 09AMQPS5878Q1ZH <br className="d-md-none" />
            <span className="d-none d-md-inline mx-2 text-secondary">|</span>
            <span className="fw-bolder text-white">MSME Registered</span>
          </div>
        </div>
        
      </div>
    </footer>
  );
}